import React from "react";
import ProductNotesModal from "./product-notes-modal";
import Parser, { attributesToProps } from "html-react-parser";
import { useState } from "react";
import { graphql } from "gatsby";

const ProductNotesModalTrigger = ({ node, attribs, onClick }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onClick(e);
  };
  return (
    <a href="/" {...attributesToProps(attribs)} onClick={handleClick}>
      {node.children[0].data}
    </a>
  );
};

const ProductNotesPriceTrigger = ({ node, attribs }) => {
  return <span {...attributesToProps(attribs)}>{node}</span>;
};

const ProductNotes = ({ data, contributoRaee, position, className }) => {
  const [productNotesData, setProductNotesData] = useState(false);
  const showProductNotesData = () => setProductNotesData(true);
  const closeProductNotesData = () => setProductNotesData(false);
  return position === "plp" ? (
    <>
      <div className={`product-notes ${className}`}>
        <div className="product-notes--title">
          {Parser(data.textFooter, {
            replace: (node) => {
              if (node.type === "tag" && node.attribs.id === "moduleRaee") {
                return (
                  <ProductNotesModalTrigger
                    node={node}
                    attribs={node.attribs}
                    onClick={showProductNotesData}
                  />
                );
              }
            },
          })}
        </div>
      </div>
      <ProductNotesModal data={data} show={productNotesData} onHide={closeProductNotesData} />
    </>
  ) : position === "pdp" ? (
    <>
      <div className="product-notes--pdp">
        <div className="product-notes--title">
          {Parser(data.textInPdp, {
            replace: (node) => {
              if (node.type === "tag") {
                if (
                  !(node.attribs.id === "moduleRaee") &&
                  !(node.attribs.id === "priceRaee" && contributoRaee)
                )
                  return;
                return (
                  <>
                    {node.attribs.id === "moduleRaee" && (
                      <ProductNotesModalTrigger
                        node={node}
                        attribs={node.attribs}
                        onClick={showProductNotesData}
                      />
                    )}
                    {node.attribs.id === "priceRaee" && contributoRaee && (
                      <ProductNotesPriceTrigger node={contributoRaee} attribs={node.attribs} />
                    )}
                  </>
                );
              }
            },
          })}
        </div>
      </div>
      <ProductNotesModal data={data} show={productNotesData} onHide={closeProductNotesData} />
    </>
  ) : null;
};

export default ProductNotes;

export const fragment = graphql`
  fragment ProductNotesFragment on LiferayProductNotes {
    textPopUp
    titlePopUp
    textFooter
    textInPdp
  }
`;
